import type { ExpenseByIdQuery } from '../../../__generated__/graphql';
import { OptionBase } from '../../../../../components/Select/types';

export const isSalesforceId = (value: string | null | undefined): boolean => {
  if (!value || typeof value !== 'string') return false;
  return value.length >= 15 && /^[a-zA-Z0-9]+$/.test(value);
};

export const shouldAddCustomMerchant = (
  merchant:
    | NonNullable<ExpenseByIdQuery['expense']>['merchant']
    | null
    | undefined,
  merchants: readonly { Id: string; Name?: string | null }[] | null | undefined,
  customMerchants: OptionBase[],
): boolean => {
  if (!merchant?.Id || !merchant?.Name) return false;

  const existsInApi = merchants?.some((m) => m.Id === merchant.Id);
  if (existsInApi) return false;

  const existsInCustom = customMerchants.some((m) => {
    return merchant.Id === m.value || merchant.Name === m.label;
  });

  return !existsInCustom;
};
